import React from "react";
import { compose, withActions } from "containers/HOC";
import * as utils from "common/utils";
import SortableTable from "components/new/SortableTable";
import SortableTableHeader from "components/new/SortableTableHeader";
import ActionLink from "components/ActionLink";
import { confirm } from "containers/App/_actions";
import { toggleAdminForUser, removeUser } from "./_actions";

const UserList = ({ users, showCount = false, authContext, toggleAdminForUser, confirm, removeUser }) => {
    const toggleAdmin = (user) => (e) => {
        toggleAdminForUser(user.id);
    };

    const remove = (user) => (e) => {
        confirm(`Are you sure you want to remove "${user.fullName}" from your organisation?`, () => removeUser(user.id), false);
    };

    return (
        <React.Fragment>
            {showCount && (
                <p className="u-mt-0 u-mb-md">
                    <span className="h3">{users.length}</span> user(s)
                </p>
            )}
            <SortableTable data={users} defaultSortCriteria={{ fieldName: "fullName" }}>
                {({ data, sortCriteria, handleSort }) => {
                    return (
                        <table>
                            <thead>
                                <tr>
                                    <SortableTableHeader label="Name" fieldName="fullName" sortCriteria={sortCriteria} handleSort={handleSort} />
                                    <SortableTableHeader label="Email" fieldName="email" sortCriteria={sortCriteria} handleSort={handleSort} />
                                    <SortableTableHeader label="Activated?" fieldName="isActivated" sortCriteria={sortCriteria} handleSort={handleSort} bool />
                                    <SortableTableHeader label="Created" fieldName="createdOn" sortCriteria={sortCriteria} handleSort={handleSort} date />
                                    <SortableTableHeader label="Modified" fieldName="modifiedOn" sortCriteria={sortCriteria} handleSort={handleSort} date />
                                    <SortableTableHeader label="Org admin?" fieldName="isAdmin" sortCriteria={sortCriteria} handleSort={handleSort} bool shrink />
                                    <th className="th--shrink"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((user) => {
                                    const isCurrentUser = user.id === authContext.userId;
                                    return (
                                        <tr key={user.email} id={user.email} className="hover">
                                            <td>{user.fullName}</td>
                                            <td>{user.email}</td>
                                            <td className="u-textCenter">{user.isActivated ? "Yes" : "-"}</td>
                                            <td>{utils.dateLong(user.createdOn, "-")}</td>
                                            <td>{utils.dateLong(user.modifiedOn, "-")}</td>
                                            <td className="u-textCenter">
                                                {!user.isAPIUser && !isCurrentUser && (
                                                    <label className="Checkbox" htmlFor={"users-isadmin-select-" + user.id}>
                                                        <input className="Checkbox-input" type="checkbox" id={"users-isadmin-select-" + user.id} checked={user.isAdmin} onChange={toggleAdmin(user)} />
                                                        <span className="Checkbox-label"></span>
                                                    </label>
                                                )}
                                                {!user.isAPIUser && isCurrentUser && "Yes"}
                                                {user.isAPIUser && "API"}
                                            </td>
                                            <td className="u-textCenter">{!user.isAPIUser && !isCurrentUser && <ActionLink id={`remove-user-${user.id}`} className="IconLink--cross-circle" onClick={remove(user)}></ActionLink>}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    );
                }}
            </SortableTable>
        </React.Fragment>
    );
};

export default compose(withActions({ toggleAdminForUser, confirm, removeUser }))(UserList);
